import React from 'react';
import Layout from './components/layout/Layout';

function App() {
  return (
    <Layout>
      <section className="hero wrapper" id="inicio">
        <p className="eyebrow">IA aplicada para negocios que quieren acelerar</p>
        <h1>
          En <span className="hero-que">que</span>
          <span className="hero-uauu">Uauu!</span> convertimos ideas en resultados sorprendentes.
        </h1>
        <p className="hero-copy">
          Creamos automatizaciones, asistentes, experiencias y herramientas con IA para
          que tu equipo haga mas, venda mejor y lance cosas Uauu sin perder semanas.
        </p>
        <div className="cta-row">
          <a className="btn-primary" href="mailto:info@queuauu.com?subject=Quiero%20hacer%20algo%20Uauu%20con%20IA">
            Escribir a info@queuauu.com
          </a>
          <a className="btn-ghost" href="#que-hacemos">Ver posibilidades IA</a>
        </div>
      </section>

      <section className="wrapper cards-section" id="que-hacemos">
        <h2>Las cosas Uauu que podemos hacer con IA</h2>
        <div className="cards-grid">
          <article className="feature-card">
            <h3>Automatizar procesos repetitivos</h3>
            <p>
              Flujos inteligentes que eliminan tareas manuales: respuestas, reportes,
              clasificacion y seguimiento en tiempo real.
            </p>
          </article>
          <article className="feature-card">
            <h3>Asistentes que venden y atienden</h3>
            <p>
              Chatbots y copilotos entrenados con tu contexto para resolver dudas,
              agendar reuniones y detectar oportunidades comerciales.
            </p>
          </article>
          <article className="feature-card">
            <h3>Prototipos rapidos con impacto</h3>
            <p>
              De concepto a demo funcional en dias, para validar ideas y lanzar productos
              digitales con menor riesgo.
            </p>
          </article>
        </div>
      </section>

      <section className="wrapper proof-section" id="casos">
        <h2>¿Que cambia cuando aplicas IA de forma inteligente?</h2>
        <ul>
          <li>Menos carga operativa y mas foco en tareas de alto valor.</li>
          <li>Mejor experiencia para clientes con respuestas mas rapidas.</li>
          <li>Decision de negocio con datos procesados en minutos.</li>
        </ul>
      </section>
    </Layout>
  );
}

export default App;
